import React, { useEffect, useRef, useState } from "react";
import { Search, X } from "react-bootstrap-icons";
import { Nav, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/heading";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";
import { ProjectsTable } from "./projectsTable";
import { FoldersTable } from "./foldersTable";
import { PagesTable } from "./pagesTable";
import { ACTIVE_TAB, SHARE_TABS } from "../../utils";
import { useUserQuery } from "../../graphql/menu.hooks";

export default function ShadedPages() {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState<string>("projects");
  const searchRef = useRef<HTMLInputElement | null>(null);

  const focusToSearchInput = () => {
    if (searchRef?.current) {
      searchRef.current.focus();
    }
  };

  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const { data: userData } = useUserQuery();

  useEffect(() => {
    if (
      !userData?.user?.countSharedDomainsToMe &&
      userData?.user?.countSharedFoldersToMe
    ) {
      setActiveTab("folders");
    } else if (userData?.user?.countSharedPagesToMe) {
      setActiveTab("pages");
    }
  }, [userData]);

  return (
    <>
      <PageHeader
        title={t("menu.shared")}
        paths={[
          { label: t("projects.main"), path: `${lng}/projects` },
          { label: t("menu.shared"), path: `${lng}/shared` },
        ]}
      />
      <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k!)}>
        <div className="shareTabs d-flex flex-column flex-md-row align-items-center mb-4">
          <Nav
            variant="tabs"
            className="mb-3 mb-md-0 p-0 border-0 col-12 col-md-auto w-fit-content mx-md-auto bg-white rounded-3"
          >
            {SHARE_TABS.map(({ id, name, Icon }) => (
              <Nav.Item key={id} className="col-4 col-md-auto">
                <Nav.Link
                  eventKey={name}
                  className={`d-flex align-items-center justify-content-center px-3 px-md-4 py-2 border-0 ${activeTab === name ? "bg-primary rounded-3" : ""}`}
                >
                  <Icon
                    className={`me-2 ${activeTab === name ? "text-white" : "text-primary"}`}
                  />
                  <p
                    className={`m-0 ms-1 fs-6 text-capitalize ${activeTab === name ? "text-white fw-bold" : "text-primary fw-normal"}`}
                  >
                    {t(`share.${name}`)}
                  </p>
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          <div className="sharedInput position-relative">
            <input
              ref={searchRef}
              type="text"
              placeholder={t("projects.search")}
              className="form-control border-0 pe-5"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {!searchTerm ? (
              <Search
                onClick={focusToSearchInput}
                className={`text-dark d-md-block position-absolute translate-middle-y top-50 end-0 me-2`}
              />
            ) : (
              <X
                onClick={() => setSearchTerm("")}
                size={24}
                className="cursor-pointer position-absolute translate-middle-y top-50 end-0 me-2"
              />
            )}
          </div>
        </div>
        <Tab.Content>
          <Tab.Pane eventKey={ACTIVE_TAB.PROJECTS}>
            <ProjectsTable searchTerm={searchTerm} />
          </Tab.Pane>
          <Tab.Pane eventKey={ACTIVE_TAB.FOLDERS}>
            <FoldersTable searchTerm={searchTerm} />
          </Tab.Pane>
          <Tab.Pane eventKey={ACTIVE_TAB.PAGES}>
            <PagesTable searchTerm={searchTerm} />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </>
  );
}
